import {Component, Input} from '@angular/core';
import {User} from "../../auth/primitives/user";
import {Base64ImageComponent} from "../base64-image/base64-image.component";
import {cameraActions} from "../../state/camera/camera.actions";
import {Store} from "@ngrx/store";
import {NgIf} from "@angular/common";

@Component({
  selector: 'search-result-user',
  standalone: true,
  imports: [
    Base64ImageComponent,
    NgIf
  ],
  templateUrl: './search-result-user.component.html',
  styleUrl: './search-result-user.component.scss'
})
export class SearchResultUserComponent {
  pUser: User
  @Input() set user(u: User) {
    this.pUser = u
  }

  constructor(
      private store: Store
  ) {
  }

  goToUser(user: User) {
    this.store.dispatch(cameraActions.targetJumped({
      target: JSON.parse(user.last_coord),
    }))
  }
}
